import React from "react";
import { Label } from "structure/Document";
import { ContextEmitCreditNote } from "..";
import { useContext } from "react";
import { mnCurrency } from "helpers/money";

export default function TotalInvoice() {
  const hook = useContext(ContextEmitCreditNote);

  return (
    <div>
      <Label required={hook.invoice === undefined}>Total (factura)</Label>
      <p>
        {hook.invoice === undefined
          ? "Primero selecciona una factura"
          : `${mnCurrency(hook.invoice.total)}`}
      </p>
    </div>
  );
}
